export const TABLE_CELL_EMPTY_VALUE = '-';
